import { SocketIo } from "App";
import { Separator } from "Components/ui/separator";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { isWithinOneMinute } from "utils";
import { getEquityData } from "../../../Redux/ChallengeOverview/ChallengeOverviewAction";
import Chart from "./Chart";
import { Skeleton } from "Components/ui/skeleton";
import { useAuth } from "@clerk/clerk-react";

function Balance() {
  const params = useParams();
  const dispatch = useDispatch();
  const filters = ["1H", "1D", "1W", "All"];
  const [selectedFilter, setSelectedFilter] = useState("1H");
  const [newData, setNewData] = useState([]);
  const [minunte, setMinunte] = useState(0);
  const { getToken } = useAuth();
  const {
    equityData,
    equityDataSuccess,
    equityDataError,
    equityDataLoading,
    challengeStageInfo,
    challengeStageInfoSuccess,
    challengeStageInfoError,
    challengeStageInfoLoading,
  } = useSelector((state) => state.ChallengeOverviewReducer);

  useEffect(() => {
    if (challengeStageInfo?.Account?.login) {
      dispatch(
        getEquityData(
          getToken,
          encodeURIComponent(challengeStageInfo?.Account?.login),
          {
            filter: selectedFilter == "All" ? "ALL" : selectedFilter,
          }
        )
      );
    }
  }, [challengeStageInfo, selectedFilter]);

  useEffect(() => {
    if (equityData?.length > 0) {
      setNewData(equityData);
    } else {
      setNewData([]);
    }
  }, [equityData]);

  useEffect(() => {
    if (challengeStageInfo?.Account?.login && newData?.length > 0) {
      SocketIo.on(challengeStageInfo?.Account?.login, (data) => {
        if (
          isWithinOneMinute(
            data.createdAt,
            newData[newData?.length - 1]?.createdAt
          )
        ) {
          const d = [...newData];
          d.push(data);
          setNewData(d);
        } else {
          const d = [...newData];

          d[d?.length - 1] = {
            ...d[d?.length - 1],
            balance: data?.balance,
            equity: data?.equity,
            PL: data?.PL,
          };
          setNewData(d);
        }
      });
    }
    return () => {
      SocketIo.off(challengeStageInfo?.Account?.login);
    };
  }, [challengeStageInfo, newData]);
  return (
    <div className="flex flex-col  w-full  p-4 px-6 rounded-lg  flex-1 bg-background border-2  border-border-darkNew ">
      <div className="flex justify-between sm:items-end sm:flex-row flex-col items-start border-b-2 border-border-darkNew pb-3 ">
        <div className="flex flex-col gap-1 sm:w-[30%] w-full">
          <span className="text-xl text-white font-N_Roman">Your Balance</span>
        </div>
        <div className="flex justify-between sm:gap-8 gap-2 bg-black-dark p-1 rounded-lg  w-fit sm:mt-0 mt-5 self-end">
          {" "}
          {filters.map((filter) => (
            <span
              className="text-white-opacity  text-sm font-N_Roman cursor-pointer hover:opacity-100 px-4 py-1 rounded-md"
              onClick={() => setSelectedFilter(filter)}
              style={{
                backgroundColor:
                  selectedFilter == filter && "var(--foreground)",
                color: selectedFilter == filter && "var(--primary)",
              }}
            >
              {filter}
            </span>
          ))}
        </div>
      </div>
      <div className="text-sm font-N_Roman flex items-center gap-12 text-white-opacity mt-8 ">
        <div className="flex flex-col gap-1">
          <div className="text-white-opacity">Balance</div>
          {challengeStageInfoLoading ? (
            <Skeleton className="h-6 sm:w-32 w-10" />
          ) : (
            <div className="text-white text-base font-N_Bold">
              {newData?.length > 0
                ? newData[newData.length - 1]?.balance.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  })
                : "-"}
            </div>
          )}
        </div>

        <div className="flex flex-col gap-1">
          <div className="text-white-opacity ">Equity</div>
          {challengeStageInfoLoading ? (
            <Skeleton className="h-6  sm:w-32 w-10" />
          ) : (
            <div className="text-white text-base  font-N_Bold">
              {newData?.length > 0
                ? newData[newData.length - 1]?.equity.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  })
                : "-"}
            </div>
          )}
        </div>
      </div>
      {challengeStageInfoLoading ? (
        <Skeleton className="w-full h-full min-h-[300px] mt-2" />
      ) : (
        <div className="bg-background-card rounded-lg mt-2">
          <Chart
            dataSets={newData?.map((data) => ({
              ...data,
              time: new Date(data.createdAt).getTime() / 1000,
              value: data.equity,
            }))}
            dataSets2={newData.map((data) => ({
              ...data,
              time: new Date(data.createdAt).getTime() / 1000,
              value: data.balance,
            }))}
          />
        </div>
      )}
    </div>
  );
}

export default Balance;
